__turbopack_context__.v({
  "closeButton": "UpdatesPanel-module-scss-module__8fpEja__closeButton",
  "content": "UpdatesPanel-module-scss-module__8fpEja__content",
  "emptyContent": "UpdatesPanel-module-scss-module__8fpEja__emptyContent",
  "emptyDescription": "UpdatesPanel-module-scss-module__8fpEja__emptyDescription",
  "emptyIllustration": "UpdatesPanel-module-scss-module__8fpEja__emptyIllustration",
  "emptyState": "UpdatesPanel-module-scss-module__8fpEja__emptyState",
  "emptyTitle": "UpdatesPanel-module-scss-module__8fpEja__emptyTitle",
  "footer": "UpdatesPanel-module-scss-module__8fpEja__footer",
  "header": "UpdatesPanel-module-scss-module__8fpEja__header",
  "notLoggedInButtons": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInButtons",
  "notLoggedInContent": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInContent",
  "notLoggedInDescription": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInDescription",
  "notLoggedInIllustration": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInIllustration",
  "notLoggedInState": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInState",
  "notLoggedInText": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInText",
  "notLoggedInTitle": "UpdatesPanel-module-scss-module__8fpEja__notLoggedInTitle",
  "notificationsList": "UpdatesPanel-module-scss-module__8fpEja__notificationsList",
  "overlay": "UpdatesPanel-module-scss-module__8fpEja__overlay",
  "panel": "UpdatesPanel-module-scss-module__8fpEja__panel",
  "signInButton": "UpdatesPanel-module-scss-module__8fpEja__signInButton",
  "signUpLink": "UpdatesPanel-module-scss-module__8fpEja__signUpLink",
  "signUpRow": "UpdatesPanel-module-scss-module__8fpEja__signUpRow",
  "signUpText": "UpdatesPanel-module-scss-module__8fpEja__signUpText",
  "title": "UpdatesPanel-module-scss-module__8fpEja__title",
  "titleRow": "UpdatesPanel-module-scss-module__8fpEja__titleRow",
  "unreadBadge": "UpdatesPanel-module-scss-module__8fpEja__unreadBadge",
  "unreadBadgeText": "UpdatesPanel-module-scss-module__8fpEja__unreadBadgeText",
  "viewAllLink": "UpdatesPanel-module-scss-module__8fpEja__viewAllLink",
});
